import { Component } from '@angular/core';
import { User } from '../models/user';
import { AuthService } from '../services/authService';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrl: './profile.component.scss',
    standalone: false
})
export class ProfileComponent {
  user = new User('', false);

  constructor(private authService: AuthService) { }

  async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? "";
        resolve(this.user.loggedin);
      });
    });
  }
}
